module.exports = __webpack_public_path__ + "img/45.f7a81805.png";